export default __webpack_public_path__ + "static/media/ios-icon-disable.0e0ec0d2.svg";